export default {
    EDIT_SCRIPT: "Редактировать скрипт",
    DELETE_SCRIPT: "Удалить",
    CONFIRM_DELETE_SCRIPT_TEXT: "Вы уверены, что хотите удалить этот скрипт?",
    CONFIRM_DELETE_SCRIPT_HEADER: "Удалить скрипт"
};
